import React from 'react';
import { FiCheck } from 'react-icons/fi';

export function StepIndicator({ currentStep, totalSteps }) {
  return (
    <div className="flex items-center justify-between w-full max-w-4xl mb-8">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <React.Fragment key={index}>
          <div className="flex flex-col items-center">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center ${
                index < currentStep
                  ? 'bg-green-600 text-white'
                  : index === currentStep
                  ? 'bg-green-100 text-green-600 border-2 border-green-600'
                  : 'bg-gray-100 text-gray-400'
              }`}
            >
              {index < currentStep ? (
                <FiCheck className="w-5 h-5" />
              ) : (
                <span>{index + 1}</span>
              )}
            </div>
            <span
              className={`text-xs mt-2 text-center max-w-16 ${
                index <= currentStep ? 'text-green-600' : 'text-gray-400'
              }`}
            >
              {
                [
                  'Campaign Setup',
                  'ICP Builder',
                  'Pain Points',
                  'Content Theme',
                  'Content Format',
                  'Customization',
                  'Review',
                ][index]
              }
            </span>
          </div>
          {index < totalSteps - 1 && (
            <div
              className={`flex-1 h-0.5 ${
                index < currentStep ? 'bg-green-600' : 'bg-gray-200'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}